import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit'
import { State } from '../../types/StateType'
import { PatientPrescription } from './types'

const patientPrescriptionAdapter = createEntityAdapter<PatientPrescription>({
  selectId: (patientPrescription) => patientPrescription.key,
})

let definedProps: { error: any; loading: boolean; success: any } = {
  error: null,
  loading: false,
  success: null,
}

const initialState = patientPrescriptionAdapter.getInitialState(definedProps)

const patientPrescriptionSlice = createSlice({
  name: 'patientPrescription',
  initialState: initialState,
  reducers: {
    getPatientPrescriptions: (state, action: PayloadAction<string>) => {
      state.loading = true
    },
    addPatientPrescriptions: (
      state,
      action: PayloadAction<PatientPrescription>
    ) => {
      state.loading = false
      patientPrescriptionAdapter.upsertOne(state, action.payload)
    },
    addPatientPrescription: (
      state,
      action: PayloadAction<{
        patientKey: string
        prescriptionText: string
      }>
    ) => {},
    deletePatientPrescription: (
      state,
      action: PayloadAction<{
        patientKey: string
        prescriptionId: string
      }>
    ) => {},

    errorPatientPrescription: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    successPatientPrescription: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.success = action.payload
    },
  },
})

export const {
  errorPatientPrescription,
  getPatientPrescriptions,
  addPatientPrescription,
  deletePatientPrescription,
  addPatientPrescriptions,
  successPatientPrescription,
} = patientPrescriptionSlice.actions

export default patientPrescriptionSlice.reducer

const { selectById } = patientPrescriptionAdapter.getSelectors()

export const selectPatientPrescriptionsById = (id: string) =>
  createSelector(
    (state: State) => state.patientPrescriptionState,
    (patientPrescription) => selectById(patientPrescription, id)
  )

export const selectErrorInPatientPrescription = createSelector(
  (state: State) => state.patientPrescriptionState.error,
  (error) => error
)
export const selectSuccessInPatientPrescription = createSelector(
  (state: State) => state.patientPrescriptionState.success,
  (success) => success
)
